import * as React from "react";

import { NomenclatureAutocompleteFilter } from "@duosoftbg/nacid-components";
import { useFormContext } from "react-hook-form";
import { useStore } from "react-redux";
import useAppSelector from "../../../../../../../hooks/redux/base/useAppSelector";
import { SEARCH_FILTERS_GROUP } from "../../../../../../../config/registers/search/filters/groupsConfig";
import { arNacidStatusesThunk } from "../../../../../../../store/redux/slice/AppData/arNacidStatuses";
import { RootState } from "../../../../../../../store/redux/store";

const ARNacidStatusFilter = ({ xs = 12, sm = 6, md = 3, group = SEARCH_FILTERS_GROUP.ACADEMIC_RECOGNITION_NACID }) => {
  const thunkState = useAppSelector((state) => {
    return state.AppData.arNacidStatuses;
  });

  const store = useStore();
  const { getValues } = useFormContext();
  const initValue = getValues("status");

  const getPreviousStateOptionFn = () => {
    const state = store.getState() as RootState;
    const statusCode = state.SearchData.searchTable[group].filtersData.status;
    const options = state.AppData.arNacidStatuses.data;
    return options.find((element) => element.id === statusCode);
  };

  return (
    <NomenclatureAutocompleteFilter
      initialValue={initValue}
      filter={"status"}
      thunkFn={arNacidStatusesThunk}
      thunkState={thunkState}
      getPreviousStateOptionFn={getPreviousStateOptionFn}
      xs={xs}
      sm={sm}
      md={md}
    />
  );
};

export default ARNacidStatusFilter;
